exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.error td[data-v-1396d77e]{background-color:#ff9b9b\n}", ""]);

// exports
